<script type="ts">
  import { createEventDispatcher } from "svelte";
  import type { SearchTrendsResponseBody } from "../../shared-types";
  import debounce from "lodash.debounce";
  import { searchTrends } from "../services/twitter/search-trends";
  import { AccessToken, AccessTokenSecret } from "../services/store";

  const dispatch = createEventDispatcher();
  export let top = 0;
  export let left = 0;
  export let query = "";
  let list: SearchTrendsResponseBody = [];
  let loading = false;
  async function onChangeQuery(q: string): Promise<void> {
    if (q.trim().length > 0) {
      const request = {
        accessToken: $AccessToken,
        accessTokenSecret: $AccessTokenSecret,
        q,
      };
      loading = true;
      try {
        const response = await searchTrends(request);
        list = response;
      } catch (err) {
        console.error(err);
      } finally {
        loading = false;
      }
    }
  }
  const debouncedQuery = debounce(onChangeQuery, 300);

  $: {
    debouncedQuery(query);
  }

  function onSelect(name: string) {
    dispatch("select", {
      name,
    });
  }
</script>

<div
  class="container"
  style={`
  top: ${top}px;
  left: ${left}px;
`}
>
  {#if loading}
    <div class="item">😎</div>
  {:else}
    {#each list as item}
      <div
        class="item"
        on:click={(event) => {
          event.stopPropagation();
          onSelect(item.name);
        }}
      >
        <div>
          <p class="name">{item.name}</p>
          <p class="popularity">{item.tweet_volume} tweets</p>
        </div>
      </div>
    {/each}
  {/if}
</div>

<style type="scss">
  .container {
    position: fixed;
    z-index: 2;
    width: 20em;
    min-height: 3em;
    display: flex;
    flex-direction: column;
    background-color: white;
    border: 1px dashed #222222;
    border-radius: 2px;
  }

  .item {
    height: 3em;
    font-size: small;
    display: flex;
    cursor: pointer;

    &:hover {
      background-color: #dddddd;
    }

    p {
      margin: 0;
    }

    .popularity {
      color: gray;
      font-size: x-small;
    }
  }
</style>
